// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { TrophyOutlined } from '@ant-design/icons';

// type
import { NavItemType } from '@trendiolive/trendio-selfcare-ui-kit';

// project import
import { SHOP_HEALTH_PATH } from 'constants/routeConstants';

// icons
const icons = { TrophyOutlined };

// ==============================|| MENU ITEMS - SHOP HEALTH ||============================== //

const shopHealth: NavItemType = {
  id: 'shop-health',
  title: <FormattedMessage id="shop-health-menu-item" />,
  type: 'group',
  url: SHOP_HEALTH_PATH,
  icon: icons.TrophyOutlined
};

export default shopHealth;
